'use client';

import Link from 'next/link';

import styles from '../../../styles/components/ui/button.module.scss';

/**
 * Reusable back button – same style as checkout step "Назад".
 * Renders as Link when href is set, otherwise as button (for onClick, e.g. checkout steps).
 * By default width is fit-content (small as text); set fullWidth for checkout step layout.
 */
export default function BackButton({
  href,
  onClick,
  children,
  fullWidth = false,
  type = 'button',
  disabled,
  className = '',
}) {
  const baseClass = [
    styles.button,
    styles.outline,
    styles.medium,
    fullWidth ? styles.fullWidth : styles.fitContent,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const content = <span className={styles.text}>&larr; {children}</span>;

  if (href != null) {
    return (
      <Link href={href} className={baseClass}>
        {content}
      </Link>
    );
  }

  return (
    <button type={type} className={baseClass} onClick={onClick} disabled={disabled}>
      {content}
    </button>
  );
}
